module.exports = __webpack_public_path__ + "img/blue_circle.7c566c97.png";